import { Injectable } from "@angular/core";
import { GDAuthInterface } from "../../model/gd-auth";
import { AppPreferences } from "../../shared/local/app-preferences.local";
import { RequestPaymentMethod } from "../../shared/nestjs/gd-only/dto/ipg.dto";
import { InappbrowserService } from "../inappbrowser/inappbrowser.service";

@Injectable()
export class IPGService {
  constructor(
    private appPreferences: AppPreferences,
    private inappbrowserService: InappbrowserService
  ) {}

  async openPaymentMethod(payload: RequestPaymentMethod) {
    const SFGoAuth: GDAuthInterface = await this.appPreferences.getAuth();
    const endpoint = SFGoAuth.greatdayMarketplaceApp + "/payment-method/";
    console.log("open payment method", endpoint);
    const data: { use: string; browser?: any; modal?: any } =
      await this.inappbrowserService.openInAppBrowserWithEncryptData(
        endpoint,
        payload,
        undefined,
        true
      );
    return data;
  }
}



// WEBPACK FOOTER //
// ./src/providers/ipg/ipg.service.ts